import { render, staticRenderFns } from "./Correlation.vue?vue&type=template&id=b9a837a4&scoped=true"
import script from "./Correlation.vue?vue&type=script&lang=js"
export * from "./Correlation.vue?vue&type=script&lang=js"
import style0 from "./Correlation.vue?vue&type=style&index=0&id=b9a837a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a837a4",
  null
  
)

export default component.exports